import { createConsumer } from "@rails/actioncable"
import { isActiveTab } from "./eduson_helpers.js"

// ActionCable-транспорт трекинга активности (за feature flag, см. data-transport).
// Протокол зеркалит Phoenix-вариант из user_activity.js: подписка на канал лекции,
// active/not_active по visibilitychange.
//
// В отличие от phoenix.js, клиент actioncable молча дропает perform() до открытия
// соединения — поэтому последнее непереданное состояние буферизуется и досылается
// в connected() (аналог push-буфера Phoenix). onRejected вызывается, если сервер
// отклонил подписку (например, флаг выключили при закешированной странице) — там
// entrypoint откатывается на легаси-трекер.
//
// Состояние подписки дублируется в data-state якоря (connected/disconnected/rejected) —
// для отладки и детерминированного ожидания в system-спеках.
const UserActivityCable = {
    init(element, onRejected) {
        if (!element) { return }

        const lectureId = element.getAttribute("data-id")
        const consumer = createConsumer()
        let pendingAction = null
        let confirmed = false
        let rejectedByServer = false

        const subscription = consumer.subscriptions.create(
            { channel: "UserActivityChannel", lecture_id: lectureId },
            {
                connected() {
                    confirmed = true
                    element.setAttribute("data-state", "connected")
                    // Буфер сбрасывается только после успешной отправки: сокет мог уже закрыться
                    if (pendingAction && this.perform(pendingAction)) {
                        pendingAction = null
                    }
                },

                disconnected() {
                    confirmed = false
                    element.setAttribute("data-state", "disconnected")
                },

                rejected() {
                    rejectedByServer = true
                    element.setAttribute("data-state", "rejected")
                    console.log("user activity subscription rejected")
                    // Teardown: подписка уже забыта консьюмером, /cable-сокет больше
                    // не нужен — дальше трекает легаси-путь
                    consumer.disconnect()
                    if (onRejected) { onRejected() }
                }
            }
        )

        isActiveTab(() => {
            // После reject трекает легаси-путь — слушатель не снять (isActiveTab
            // не отдаёт ссылку на обработчик), поэтому глушим его флагом
            if (rejectedByServer) { return }

            const action = isActiveTab() ? "active" : "not_active"

            // perform возвращает false, если сокет ещё/уже не открыт —
            // тогда состояние досылается из connected()
            if (!confirmed || !subscription.perform(action)) {
                pendingAction = action
            }
        })
    }
}
export default UserActivityCable
